export enum PurchaseOrderStatus {
  Pending,
  Rejected,
  RequestForQuotation,
  RequestForChange,
  Approved,
  Draft,
}

export function getPurchaseOrderStatusInfo(status: PurchaseOrderStatus): {
  name: string;
  color: string;
} {
  const { Approved, Pending, Rejected, RequestForChange, RequestForQuotation, Draft } =
    PurchaseOrderStatus;

  switch (status) {
    case Pending:
      return { name: "Pending", color: "#3377E6" };
    case Rejected:
      return { name: "Rejected", color: "#B93E5C" };
    case RequestForQuotation:
      return { name: "RequestForQuotation", color: "#DE8F16" };
    case RequestForChange:
      return { name: "RequestForChange", color: "#993FE8" };
    case Approved:
      return { name: "Approved", color: "#368E71" };
    case Draft:
      return { name: "Draft", color: "#ad9517" };
    default:
      return { name: "Unknown", color: "black" }; // Fallback case
  }
}

export const purchaseOrderStatusArray = Object.keys(PurchaseOrderStatus)
  .filter((key) => isNaN(Number(key))) // Filter out numeric keys
  .map((key) => ({
    value: PurchaseOrderStatus[key as keyof typeof PurchaseOrderStatus], // Enum value
    label: key, // Enum name
  }));

export const purchaseOrderStatusArrayWithIdAndTitle = Object.keys(
  PurchaseOrderStatus
)
  .filter((key) => isNaN(Number(key))) // Filter out numeric keys
  .map((key) => ({
    id: PurchaseOrderStatus[key as keyof typeof PurchaseOrderStatus], // Use the enum value as the ID
    title: key, // Enum name as the title
  }));
